export enum AdsTitleEnum {
  ACC_SCREENING_JOB_POSTING = 'ACC_SCREENING_JOB_POSTING',
  CURATION_JOB_POSTING = 'CURATION_JOB_POSTING',
  MAIN_BANNER = 'MAIN_BANNER',
  RECOMMEND_JOB_POSTING = 'RECOMMEND_JOB_POSTING',
}

export type AdsTitleType = keyof typeof AdsTitleEnum;
